
<h2 mat-dialog-title cdkFocusRegionStart>{{gridText}}</h2>
<mat-dialog-content class="mat-typography">
  <p>{{note}}</p>
    <aims-common-table id="{{name}}" #lookupTable="aimsTable"
        [dataSource]="data | async"
        [header]="columnsInGrid"
        [permissions]="permissions"
        (rowClick)="gridSelectionChange($event)"
        [pageSize]="5">
    </aims-common-table>
    <br/>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <div class="thirds">
        <aims-common-button
              title="Delete"
              aria-label="Delete"
              mat-dialog-close
              (click)="nullLookup()"
              matTooltip="Clear the current selection"
            >
              <mat-icon color="warn">delete</mat-icon> Clear
            </aims-common-button>
    </div>
    <div class="thirds">
        <aims-common-button
              title="Cancel"
              aria-label="Cancel"
              mat-dialog-close
              matTooltip="Cancel current action"
            >
              <mat-icon color="basic">close</mat-icon> Cancel
            </aims-common-button>
    </div>
    <div class="thirds">
        <aims-common-button
              title="Select"
              aria-label="Select"
              mat-dialog-close
              (click)="clickSelectBtn()"
              matTooltip="Select highlighted record"
            >
              <mat-icon color="primary">save_alt</mat-icon> Select
            </aims-common-button>
    </div>
</mat-dialog-actions>

